import api from "../../../utils/api";
import { download_file } from "../../../utils/general";
import { setAlert } from "../alert";
import { handleError } from "../errors";
import { GET_CLIENT_BANK_DETAILS, GET_CLIENT_BANK_DETAILS_ERROR, GET_CLIENT_CALCULATE_INVOICE_PAYMENT, GET_CLIENT_CALCULATE_INVOICE_PAYMENT_ERROR, GET_CLIENT_CURRENCY_LIST, GET_CLIENT_CURRENCY_LIST_ERROR, GET_CLIENT_INVOICE_BY_REFNUM, GET_CLIENT_INVOICE_BY_REFNUM_ERROR, GET_CLIENT_INVOICE_LIST, GET_CLIENT_INVOICE_LIST_ERROR, GET_CLIENT_INVOICE_PAYMENT, GET_CLIENT_INVOICE_PAYMENT_ERROR, GET_CLIENT_INVOICE_PAYMENT_GATEWAY, GET_CLIENT_INVOICE_PAYMENT_GATEWAY_ERROR, GET_CLIENT_INVOICE_STATUS_LIST, GET_CLIENT_INVOICE_STATUS_LIST_ERROR, RESET_CLIENT_INVOICE_DETAILS, RESET_CLIENT_INVOICE_PAYMENT_DETAILS, SAVE_CLIENT_INVOICE_PAYMENTS, SAVE_CLIENT_INVOICE_PAYMENTS_ERROR } from "../types";

export const get_client_invoice_list = ({
    from,
    to,
    invoiceRefNum,
    status,
}) => async (dispatch) => {
    try {
        const res = await api.get(`api/cli-invoice/get-invoice-list`, {
            params: {
                invoiceRefNum,
                status,
                startDate: from,
                endDate: to,
            }
        })
        dispatch({
            type: GET_CLIENT_INVOICE_LIST,
            payload: res.data
        })
    } catch (err) {
        handleError(err, dispatch)
        dispatch({
            type: GET_CLIENT_INVOICE_LIST_ERROR
        })
    }
}

export const get_client_invoice_status_list = () => async (dispatch) => {
    try {
        const res = await api.get(`api/cli-invoice/get-invoice-status-list`)
        dispatch({
            type: GET_CLIENT_INVOICE_STATUS_LIST,
            payload: res.data
        })
    } catch (err) {
        handleError(err, dispatch)
        dispatch({
            type: GET_CLIENT_INVOICE_STATUS_LIST_ERROR
        })
    }
}

export const download_client_invoice = (refNums) => async (dispatch) => {
    try {
        const res = await api.post(`api/cli-invoice/download-invoices`, refNums, { responseType: 'blob' });

        const contentDisposition = res.headers.get('Content-Disposition');
        let filename = 'downloaded_client_Inv_' + refNums.refNumList.toString().split(',').join('_') + '.csv';
        if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
            const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
            if (filenameMatch.length === 2) {
                filename = filenameMatch[1];
            }
        }
        download_file(res.data, filename, 'application/octet-stream')
    } catch (err) {
        const success = err.response.data.success;
        if (!success) {
            dispatch(setAlert(err.response.data.message, "danger"));
        }
    }
}

export const get_client_invoice_by_refnum = (invoiceRefNum) => async (dispatch) => {
    try {
        const res = await api.get(`api/cli-invoice/get-invoice?invoiceRefNum=${invoiceRefNum}`);
        dispatch({
            type: GET_CLIENT_INVOICE_BY_REFNUM,
            payload: res.data
        })
        return true;
    } catch (err) {
        handleError(err, dispatch);
        dispatch({
            type: GET_CLIENT_INVOICE_BY_REFNUM_ERROR,
        });
        return false;
    }
}

export const get_client_calculate_invoice_payment = (invoiceRefNum, currencyId, paymentAmount) => async (dispatch) => {
    try {
        const res = await api.get(`api/cli-invoice/calculate-invoice-payment?invoiceRefNum=${invoiceRefNum}&paymentCurrencyId=${currencyId}&paymentAmount=${paymentAmount}`);
        dispatch({
            type: GET_CLIENT_CALCULATE_INVOICE_PAYMENT,
            payload: res.data
        })

    } catch (err) {
        handleError(err, dispatch);
        dispatch({
            type: GET_CLIENT_CALCULATE_INVOICE_PAYMENT_ERROR,
        });
    }
}

export const save_client_invoice_payments = (invoicePayment) => async (dispatch) => {
    try {
        const res = await api.post('api/cli-invoice/save-invoice-payment', invoicePayment);
        dispatch(setAlert(res.data.message, 'success'))
        dispatch({
            type: SAVE_CLIENT_INVOICE_PAYMENTS,
            payload: res.data
        })
        return true;
    } catch (err) {
        handleError(err, dispatch);
        dispatch({ type: SAVE_CLIENT_INVOICE_PAYMENTS_ERROR })
        return false;
    }
}

export const get_client_invoice_payment = (invoiceRefNum) => async (dispatch) => {
    try {
        // const res = await api.get(`api/cli-invoice/get-invoice-payment?invoiceRefNum=${invoiceRefNum}`);
        const res = await api.get(`api/cli-invoice/get-invoice-payment?refNum=${invoiceRefNum}`);
        dispatch({
            type: GET_CLIENT_INVOICE_PAYMENT,
            payload: res.data
        })

    } catch (err) {
        handleError(err, dispatch);
        dispatch({
            type: GET_CLIENT_INVOICE_PAYMENT_ERROR,
        });
    }
}

export const download_payment_instruction = (refNum) => async (dispatch) => {
    try {
        const res = await api.get(`api/cli-invoice/download-payment-instruction?refNum=${refNum}`, {
            responseType: 'blob'
        });

        const contentDisposition = res.headers.get('Content-Disposition');
        let filename = 'downloaded_payment_invoice_' + refNum + '.pdf';
        if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
            const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
            if (filenameMatch.length === 2) {
                filename = filenameMatch[1];
            }
        }
        download_file(res.data, filename)
    } catch (err) {
        const success = err.response.data.success;
        if (!success) {
            dispatch(setAlert(err.response.data.message, "danger"));
        }
    }
}

export const get_client_currency_list = () => async (dispatch) => {
    try {
        const res = await api.get(`api/client/getCurrencyList`)
        dispatch({
            type: GET_CLIENT_CURRENCY_LIST,
            payload: res.data
        })
    } catch (err) {
        handleError(err, dispatch)
        dispatch({
            type: GET_CLIENT_CURRENCY_LIST_ERROR
        })
    }
}

export const get_client_invoice_payment_gateway = (invoiceRefNum) => async (dispatch) => {
    try {
        const res = await api.get(`api/cli-invoice/update-payment-status-received?refNum=${invoiceRefNum}`);
        dispatch({
            type: GET_CLIENT_INVOICE_PAYMENT_GATEWAY,
            payload: res.data
        })
        dispatch(setAlert(res.data.message, 'success'))
        return true;
    } catch (err) {
        handleError(err, dispatch);
        dispatch({
            type: GET_CLIENT_INVOICE_PAYMENT_GATEWAY_ERROR,
        });
        return false;
    }
}

export const reset_client_invoice_details = () => (dispatch) => dispatch({ type : RESET_CLIENT_INVOICE_DETAILS });
export const reset_client_invoice_payment_details = () => (dispatch) => dispatch({ type : RESET_CLIENT_INVOICE_PAYMENT_DETAILS });

export const get_client_bank_details = () => async (dispatch) => {
    try {
        const res = await api.get(`api/cli-invoice/get-bank-details`)
        dispatch({
            type: GET_CLIENT_BANK_DETAILS,
            payload: res.data
        })
    } catch (err) {
        handleError(err, dispatch)
        dispatch({
            type: GET_CLIENT_BANK_DETAILS_ERROR
        })
    }
}